module.exports = __webpack_public_path__ + "img/product_stkr_signature.2e6b376b.svg";